const headerItems = [
  {
    label: 'Legal Notice',
    slug: 'legal',
    href: 'https://adaures.com/legal/',
  },
]

export default headerItems
